import React, { useState, Fragment }  from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    section: {
        marginBottom: theme.spacing(3)
    },
    input: {
        display: 'none',
    },
}));

export default function Step2(props) {

    const { app, setLoading, refreshClub, stripeClub } = props;

    const [ idType, setIdType ] = useState('passport');
    const [ fileFront, setFileFront ] = useState(null);
    const [ fileBack, setFileBack ] = useState(null);

    const [ errors, setErrors ] = useState({});

    const classes = useStyles();
    const api = useApi();

    // Setters -------------------------------------------------

    const handleIdType = e => {
        const value = e.target.value;
        setIdType(value);
    }

    const handleFileFront = () => {
        const fileInput = document.getElementById('import-file-front');
        setFileFront(fileInput.files[0]);
    }

    const handleFileBack = () => {
        const fileInput = document.getElementById('import-file-back');
        setFileBack(fileInput.files[0]);
    }

    // Posters -------------------------------------------------

    const postVerify = () => {

        setLoading(true);

        let formData = new FormData();

        formData.append('idType', idType);
        formData.append('fileFront', fileFront);

        if (idType != 'passport') {
            formData.append('fileBack', fileBack);
        }

        api.post('/admin/accounting/stripe/verify', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            refreshClub();
        }).catch(error => {
            setLoading(false);

            if (error?.response?.data?.errors) {
                setErrors(error.response.data.errors)
            }
        });
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    return (
        <form>
            <Grid container justify="space-between" align="center" className={classes.section}>
                <Grid item>
                    <Typography variant="h6" component="h2">
                        <Typography variant="inherit" component="span" color="primary">
                            Step 2:&nbsp;
                        </Typography>
                        <Typography variant="inherit" component="span">
                            Verify Your Identity
                        </Typography>
                    </Typography>
                </Grid>
                <Grid item>

                </Grid>
            </Grid>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textSecondary" className={classes.section}>
                        We need to upload a personal photo id for you and send it to our payment processor to verify your identity. Please make sure your upload meets the following requirements:
                        <ul>
                            <li>Color Image</li>
                            <li>10 MB or less</li>
                            <li>JPG or PNG</li>
                        </ul>
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        id="input-select-id-type"
                        select
                        label="Select Identification Option"
                        value={idType}
                        onChange={handleIdType}
                        error={isError('id_type')}
                        helperText={getErrorMessage('id_type')}
                        variant="outlined"
                        fullWidth
                        >
                        <MenuItem value="passport">
                            Passport
                        </MenuItem>
                        <MenuItem value="drivers-license">
                            Drivers License
                        </MenuItem>
                        <MenuItem value="id-card">
                            ID Card
                        </MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        Please select the type of ID you want to use to verfiy your identity.
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <input
                        accept="image/jpeg, image/png"
                        className={classes.input}
                        id="import-file-front"
                        type="file"
                        onChange={handleFileFront}
                    />
                    <label htmlFor="import-file-front">
                        <Button component="span" variant="outlined" color="primary">
                            Open
                        </Button>
                    </label>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="subtitle2" color={ fileFront ? "primary" : 'error'}>
                        { fileFront ? fileFront.name : 'no file selected'}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                        Please select the image file of the <strong>front</strong> of your identification.
                    </Typography>
                </Grid>
                {idType !== 'passport' &&
                    <Fragment>

                        <Grid item xs={2}>
                            <input
                                accept="image/jpeg, image/png"
                                className={classes.input}
                                id="import-file-back"
                                type="file"
                                onChange={handleFileBack}
                            />
                            <label htmlFor="import-file-back">
                                <Button component="span" variant="outlined" color="primary">
                                    Open
                                </Button>
                            </label>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle2" color={ fileBack ? "primary" : 'error'}>
                                { fileBack ? fileBack.name : 'no file selected'}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                                Please select the image file of the <strong>back</strong> of your identification.
                            </Typography>
                        </Grid>
                    </Fragment>
                }
                <Grid item xs={8}>

                </Grid>
                <Grid item xs={4} align="right">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={postVerify}
                        >
                        Verify Identity
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
